import { InfoComponent } from './info.component';
import { Observable } from 'rxjs';
import { ModalService } from '@bayclubs/utils';
import { Injectable } from '@angular/core';

@Injectable()
export class InfoService {

    constructor(private modal: ModalService) {

    }

    show(title: string, text: string): void {
        return Observable.create(() => {
            this.modal.create<InfoComponent>(InfoComponent, {
                title: title,
                text: text,
            });
        }).subscribe();
    }
}
